<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="text-center fw-bold w-100">
            {{ pageMode() === PageMode.create ? ("breadcrumbs.faqs_category.new" | translate) : ("breadcrumbs.faqs_category.edit" | translate) }}
        </h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body overflow-x-hidden p-3">
        <form class="col-12" [formGroup]="faqsCategoryForm">
            <div class="bg-card shadow-md rounded p-2 mb-3">
                <div class="row">
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <adaa-form-input
                            [label]="'common.form.label.nameAE' | translate"
                            formControlName="nameAE"
                            controlName="nameAE"
                            [invalid]="checkInvalid('nameAE')"
                            [setValidator]="formValidation()!"
                        ></adaa-form-input>
                    </div>
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <adaa-form-input
                            [label]="'common.form.label.nameEN' | translate"
                            formControlName="nameEN"
                            controlName="nameEN"
                            [invalid]="checkInvalid('nameEN')"
                            [setValidator]="formValidation()!"
                        ></adaa-form-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 my-2">
                        <adaa-form-input-file
                            [onDeleteRemoveFile]="false"
                            [allowedFileSize]="100024"
                            [allowedFiles]="[FileInputType.svg]"
                            [file]="getImage()"
                            [controlName]="'iconAttachment'"
                            [setValidator]="formValidation()!"
                            [invalid]="checkInvalid('iconAttachment')"
                            (inputChanges)="onFileChange($event)"
                        ></adaa-form-input-file>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal=footer d-flex justify-content-center mt-3">
        <div class="my-2">
            <adaa-form-action-buttons
                [showSaveButton]="pageMode() !== PageMode.view"
                [saveButtonTitle]="'common.form.button.submit' | translate"
                [cancelButtonTitle]="
                    pageMode() === PageMode.view ? ('common.form.button.close' | translate) : ('common.form.button.cancel' | translate)
                "
                (cancelClicked)="modal.close()"
                (saveClicked)="submit()"
            ></adaa-form-action-buttons>
        </div>
    </div>
</ng-template>
